import Vue from 'vue'
import Vuex, { StoreOptions } from 'vuex'
import { RootState } from './types'
import { login } from './login/'

Vue.use(Vuex)

const store: StoreOptions<RootState> = {
  state: {},
  modules: {
    login
  }
}

export default new Vuex.Store<RootState>(store)
